var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"46","cy":"46","r":"46","fill":"currentColor","key":0}),React.createElement("polygon",{"fill":"#FFF","points":"50 35 67 61 33 61","transform":"rotate(90 50 48)","key":1})]));
}

Play.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 92 92"};

module.exports = Play;

Play.default = Play;
